import { render, staticRenderFns } from "./PromotionFields.vue?vue&type=template&id=d8f1cafa&scoped=true&"
import script from "./PromotionFields.vue?vue&type=script&lang=js&"
export * from "./PromotionFields.vue?vue&type=script&lang=js&"
import style0 from "./PromotionFields.vue?vue&type=style&index=0&id=d8f1cafa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f1cafa",
  null
  
)

export default component.exports